import { createSignal } from "solid-js";

/**
 * Bounded ring buffer for streaming numeric data (e.g. Fastly 1s ticks).
 * Backed by a Float32Array for cheap uPlot rendering.
 */
export function createStreamBuffer(capacity: number) {
  const xs = new Float32Array(capacity);
  const ys = new Float32Array(capacity);
  let len = 0;
  const [version, setVersion] = createSignal(0);

  function push(x: number, y: number) {
    if (len < capacity) {
      xs[len] = x;
      ys[len] = y;
      len++;
    } else {
      xs.copyWithin(0, 1);
      ys.copyWithin(0, 1);
      xs[capacity - 1] = x;
      ys[capacity - 1] = y;
    }
    setVersion((v) => v + 1);
  }

  return {
    push,
    version,
    series: () => [xs.subarray(0, len), ys.subarray(0, len)] as const,
  };
}
